import React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { AllApplicationPermissions } from '../../Config/PermissionConfig';
import { isUserAuthorised } from '../../Hooks/usePermissionLoader';
import { ErrorAccessDenied } from '../SplashScreens/ErrorAccessDenied';

type AuthorizeRouteProps = {
    path?: string;
    exact?: boolean;
    permission: AllApplicationPermissions | AllApplicationPermissions[];
    component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    render?(props: RouteComponentProps<any>): React.ReactNode;
};

export const AuthorizedRoute = ({ path, permission, component: Component, render, ...rest }: AuthorizeRouteProps) => (
    <Route
        {...rest}
        render={props => {
            const isAuthorised = isUserAuthorised(permission);
            if (!isAuthorised) return <ErrorAccessDenied requestedPermission={permission} />;

            if (render) return render(props);

            if (Component) return <Component {...props} />;

            throw new Error(`AuthorizedRoute does not have a component or render passed to it - path: ${path}`);
        }}
    />
);
